<template>
  <div>
    <a-pagination
      :current="this.page"
      :page-size="this.size"
      :total="this.contentSize"
      :showSizeChanger="this.showSizeChanger"
      :pageSizeOptions="this.pageSizeOptions"
      @change="change"
      @showSizeChange="change"
      style="margin-top: 1%;text-align: right"
    />
  </div>
</template>
<script>

export default {
  name: 'PageUtil',
  props: {
    contentSize: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 20
    },
    showSizeChanger: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showQuickJumper: true,
      pageSizeOptions: ['5', '10', '15', '50', '100', '1000']
    }
  },
  methods: {
    change(page, size) {
      this.$emit('change', { page: page === 0 ? 1 : page, size: size })
    }
  }
}
</script>
